import { render, staticRenderFns } from "./FeatureImages.vue?vue&type=template&id=6280485a&scoped=true&"
import script from "./FeatureImages.vue?vue&type=script&lang=ts&"
export * from "./FeatureImages.vue?vue&type=script&lang=ts&"
import style0 from "./FeatureImages.vue?vue&type=style&index=0&id=6280485a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6280485a",
  null
  
)

export default component.exports